import { useTaskTableState } from '../../providers/TaskTableStateProvider'
import { useControlledTaskTableState } from '../../providers/ControlledTaskTableStateProvider'
import { useAllTaskTableState } from '../../providers/AllTaskTableStateProvider'
import { useControlledInfiniteTaskTableState } from '../../providers/ControlledInfiniteTaskTableStateProvider'

const useCombinedTableState = () => {
  // Since only one of three providers wraps each table,
  // this hook is used to get the correct state
  const table = useTaskTableState()
  const controlledTable = useControlledTaskTableState()
  const allTasks = useAllTaskTableState()
  const infiniteTasks = useControlledInfiniteTaskTableState()

  return table ?? controlledTable ?? allTasks ?? infiniteTasks
}

export default useCombinedTableState
